import { Settings } from "lucide-react";
import { useTranslation } from "react-i18next";

// Indicatore animato condiviso per gli upload: ingranaggio che ruota + messaggio di stato.
export const UploadBusy = ({ percent = null, className = "" }) => {
  const { t } = useTranslation();
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} role="status" aria-live="polite" data-testid="upload-busy">
      <Settings className="w-4 h-4 animate-spin" aria-hidden="true" />
      <span>{t("pd.uploading")}{typeof percent === "number" ? ` ${Math.round(percent)}%` : ""}</span>
    </span>
  );
};
